import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { ForBrands } from './components/ForBrands';
import { ForOrganizers } from './components/ForOrganizers';
import { WhyAI } from './components/WhyAI';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { LoginModal } from './components/LoginModal';
import { Dashboard } from './pages/Dashboard';
import { SignupFlow } from './pages/SignupFlow';
// Access code for waitlisted users - share this URL: yoursite.com?access=sponsrai2024
const DASHBOARD_ACCESS_CODE = 'sponsrai2024';
export function App() {
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  // New state for signup flow
  const [signupRole, setSignupRole] = useState<'brand' | 'organizer' | null>(null);
  const [profileData, setProfileData] = useState<any>(null);
  useEffect(() => {
    document.title = 'SponsrAI - Sponsorships Made Simple';
    // Check if user has stored access (already logged in before)
    const storedAccess = localStorage.getItem('sponsrai_access');
    const storedUser = localStorage.getItem('sponsrai_user');
    if (storedAccess && storedUser) {
      const user = JSON.parse(storedUser);
      setProfileData(user);
      // Optionally auto-login
      // setShowDashboard(true)
    }
    // Check URL for direct access code
    const urlParams = new URLSearchParams(window.location.search);
    const accessCode = urlParams.get('access');
    if (accessCode) {
      localStorage.setItem('sponsrai_access', accessCode);
      setShowDashboard(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);
  const handleLoginSuccess = () => {
    setLoginModalOpen(false);
    setShowDashboard(true);
  };
  const handleLogout = () => {
    localStorage.removeItem('sponsrai_access');
    setShowDashboard(false);
    setSignupRole(null);
  };
  const handleSignupComplete = (data: any) => {
    setProfileData(data);
    // Save to local storage for persistence
    localStorage.setItem('sponsrai_user', JSON.stringify(data));
    // Automatically log them in
    localStorage.setItem('sponsrai_access', 'signup-complete');
    setSignupRole(null);
    setShowDashboard(true);
  };
  // 1. Show Dashboard if logged in
  if (showDashboard) {
    return <Dashboard role={profileData?.type === 'Brand' ? 'brand' : 'organizer'} // Default or from data
    profileData={profileData} onBack={handleLogout} data-id="element-0" />;
  }
  // 2. Show Signup Flow if role selected
  if (signupRole) {
    return <SignupFlow role={signupRole} onComplete={handleSignupComplete} onBack={() => setSignupRole(null)} data-id="element-1" />;
  }
  // 3. Show Landing Page
  return <div className="bg-slate-900 min-h-screen text-slate-50 selection:bg-cyan-500/30" data-id="element-2">
      <Navigation onLoginClick={() => setLoginModalOpen(true)} data-id="element-3" />

      <main data-id="element-4">
        <Hero onBrandClick={() => setSignupRole('brand')} onOrganizerClick={() => setSignupRole('organizer')} data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <ForBrands onCtaClick={() => setSignupRole('brand')} data-id="element-7" />
        <ForOrganizers onCtaClick={() => setSignupRole('organizer')} data-id="element-8" />
        <WhyAI data-id="element-9" />
        <FinalCTA onBrandClick={() => setSignupRole('brand')} onOrganizerClick={() => setSignupRole('organizer')} data-id="element-10" />
      </main>
      <Footer data-id="element-11" />

      <LoginModal isOpen={loginModalOpen} onClose={() => setLoginModalOpen(false)} onSuccess={handleLoginSuccess} data-id="element-12" />
    </div>;
}